export function parseCallbackUrl(url) {
    const parsed = new URL(url);
    const query = {};
    parsed.searchParams.forEach((value, key) => {
        query[key] = value;
    });
    const fragmentParams = new URLSearchParams(parsed.hash.replace(/^#/, ''));
    const fragment = {};
    fragmentParams.forEach((value, key) => {
        fragment[key] = value;
    });
    return { query, fragment };
}
export function getOAuthErrorFromQuery(source) {
    const get = (k) => (source instanceof URLSearchParams ? source.get(k) ?? undefined : source[k]);
    const error = get('error') || get('errorCode');
    const description = (get('error_description') || get('errorDescription') || get('message'))?.trim();
    if (!error && !description)
        return undefined;
    const provider = (get('provider') || get('oauth_provider') || '').toString() || undefined;
    // Normalize well-known codes
    const code = (error || 'oauth-failed').toString();
    return { code, description: description || code, provider };
}
export function getTokensFromParams(query, fragment) {
    const accessToken = fragment['accessToken'] ?? fragment['access_token'] ?? query['token'];
    const refreshToken = fragment['refreshToken'] ?? fragment['refresh_token'] ?? query['refresh_token'];
    const jti = fragment['jti'] ?? fragment['session'] ?? query['jti'];
    const signupToken = fragment['signup_token'] ?? fragment['signupToken'] ?? query['signup_token'] ?? query['signupToken'];
    return { accessToken, refreshToken, jti, signupToken };
}
export function parseLocationForOAuthError(loc) {
    const q = new URLSearchParams(loc.search);
    return getOAuthErrorFromQuery(q);
}
export function clearQueryFromLocation(loc) {
    const { pathname, hash } = loc;
    // Drop search; preserve hash and pathname
    const newUrl = pathname + (hash || '');
    if (typeof loc.replaceState === 'function') {
        loc.replaceState(null, '', newUrl);
    }
    else {
        const win = globalThis.window;
        if (win?.history?.replaceState) {
            win.history.replaceState(null, '', newUrl);
        }
    }
}
//# sourceMappingURL=redirectUtils.js.map